// extracted by mini-css-extract-plugin
export default {"button":"button_button__1hsaP","gradient2":"button_gradient2__4w-B3"};